export default __webpack_public_path__ + "static/media/ai-image-generator-screenshot-01.414ffde0.png";